"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewAnnotationData = exports.Annotation = exports.AnnotationData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var AnnotationData = /** @class */ (function () {
    function AnnotationData(args) {
        this.pk = args.pk;
        this.handgrading_rubric = args.handgrading_rubric;
        this.short_description = args.short_description;
        this.long_description = args.long_description;
        this.deduction = args.deduction;
        this.max_deduction = args.max_deduction;
        this.last_modified = args.last_modified;
    }
    return AnnotationData;
}());
exports.AnnotationData = AnnotationData;
var Annotation = /** @class */ (function (_super) {
    __extends(Annotation, _super);
    function Annotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Annotation.subscribe = function (observer) {
        Annotation._subscribers.add(observer);
    };
    Annotation.unsubscribe = function (observer) {
        Annotation._subscribers.delete(observer);
    };
    Annotation.get_all_from_handgrading_rubric = function (handgrading_rubric_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/handgrading_rubrics/" + handgrading_rubric_pk + "/annotations/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new Annotation(data); })];
                }
            });
        });
    };
    Annotation.get_by_pk = function (annotation_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/annotations/" + annotation_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Annotation(response.data)];
                }
            });
        });
    };
    Annotation.create = function (handgrading_rubric_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/handgrading_rubrics/" + handgrading_rubric_pk + "/annotations/", data)];
                    case 1:
                        response = _a.sent();
                        result = new Annotation(response.data);
                        Annotation.notify_annotation_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Annotation.notify_annotation_created = function (annotation) {
        var e_1, _a;
        try {
            for (var _b = __values(Annotation._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_annotation_created(annotation);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Annotation.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/annotations/" + this.pk + "/", utils_1.filter_keys(this, Annotation.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        Annotation.notify_annotation_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Annotation.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/annotations/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        if (last_modified !== this.last_modified) {
                            Annotation.notify_annotation_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Annotation.notify_annotation_changed = function (annotation) {
        var e_2, _a;
        try {
            for (var _b = __values(Annotation._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_annotation_changed(annotation);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Annotation.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/annotations/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        Annotation.notify_annotation_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Annotation.notify_annotation_deleted = function (annotation) {
        var e_3, _a;
        try {
            for (var _b = __values(Annotation._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_annotation_deleted(annotation);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    Annotation.get_order = function (handgrading_rubric_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/handgrading_rubrics/" + handgrading_rubric_pk + "/annotations/order/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    Annotation.update_order = function (handgrading_rubric_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/handgrading_rubrics/" + handgrading_rubric_pk + "/annotations/order/", data)];
                    case 1:
                        response = _a.sent();
                        result = response.data;
                        Annotation.notify_annotations_order_updated(result, handgrading_rubric_pk);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Annotation.notify_annotations_order_updated = function (annotation_list, handgrading_rubric_pk) {
        var e_4, _a;
        try {
            for (var _b = __values(Annotation._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_annotations_order_changed(annotation_list, handgrading_rubric_pk);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    Annotation._subscribers = new Set();
    Annotation.EDITABLE_FIELDS = [
        'short_description',
        'long_description',
        'deduction',
        'max_deduction',
    ];
    return Annotation;
}(AnnotationData));
exports.Annotation = Annotation;
var NewAnnotationData = /** @class */ (function () {
    function NewAnnotationData(args) {
        this.short_description = args.short_description;
        this.long_description = args.long_description;
        this.deduction = args.deduction;
        this.max_deduction = args.max_deduction;
    }
    return NewAnnotationData;
}());
exports.NewAnnotationData = NewAnnotationData;
//# sourceMappingURL=annotation.js.map